import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <g fill="none" fillRule="evenodd">
      <polygon fill="#119639" points="16 0 29.856 8 29.856 24 16 32 2.144 24 2.144 8"/>
      <path fill="#FFF" fillRule="nonzero"
            d="M4.16930657,5.51230879 L4.16930657,13.887882 C4.16930657,14.7754825 3.44976421,15.4950249 2.56216371,15.4950249 C1.67456322,15.4950249 0.955020857,14.7754825 0.955020857,13.887882 L0.955020857,1.63200664 C0.955020857,0.200150644 2.68623401,-0.516882914 3.69865078,0.495650486 L13.2094845,10.0075799 L13.2094845,1.63200664 C13.2094845,0.744406152 13.9290269,0.0248637857 14.8166274,0.0248637857 C15.7042278,0.0248637857 16.4237702,0.744406152 16.4237702,1.63200664 L16.4237702,13.887882 C16.4237702,15.319738 14.6925571,16.0367716 13.6801403,15.0242382 L4.16930657,5.51230879 Z"
            transform="translate(7 8)"/>
    </g>
  </svg>
);
